var _g, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgHAboutImgArrow(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 48,
    height: 40,
    viewBox: "0 0 48 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_11_284)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M30.73 15.6899C26.09 11.2199 22.46 6.52995 20.96 0.0199479C23.63 0.0199479 26.03 -0.0600521 28.41 0.0799479C28.99 0.109948 29.78 0.709948 30.05 1.25995C33.4 8.20995 39.05 12.7299 45.76 16.0499C47.47 16.8999 47.67 17.9999 47.64 19.6099C47.61 21.2399 47.58 22.4899 45.74 23.3999C39.02 26.7099 33.39 31.2399 30.03 38.1899C29.75 38.7699 28.81 39.3299 28.14 39.3799C25.91 39.5299 23.66 39.4399 20.97 39.4399C22.45 32.8299 26.24 28.1299 31.63 23.7799H0V15.6899H30.73Z",
    fill: "#6201FF"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_11_284"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 47.64,
    height: 39.45,
    fill: "white"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgHAboutImgArrow);
export default __webpack_public_path__ + "static/media/h-about-img-arrow.8b7f0e6284eaf47d4c0906a894416344.svg";
export { ForwardRef as ReactComponent };